export const AFTERCARE_FORM_NEXT_STEP = 'AFTERCARE_FORM_NEXT_STEP';
export const AFTERCARE_FORM_GOTO_STEP = 'AFTERCARE_FORM_GOTO_STEP';
export const AFTERCARE_FORM_RESET = 'AFTERCARE_FORM_RESET';
export const AFTERCARE_FORM_SUBMIT = 'AFTERCARE_FORM_SUBMIT';
export const AFTERCARE_FORM_PREFILL = 'AFTERCARE_FORM_PREFILL';
export const AFTERCARE_FORM_SET_IS_DRAFT = 'AFTERCARE_FORM_SET_IS_DRAFT';
export const AFTERCARE_FORM_DUPLICATE_TOGGLE = 'AFTERCARE_FORM_DUPLICATE_TOGGLE';
export const AFTERCARE_FORM_SET_FORM_VALID = 'AFTERCARE_FORM_SET_FORM_VALID';
//step 1
export const AFTERCARE_FORM_SET_AFTERCARE_NAME = 'AFTERCARE_FORM_SET_AFTERCARE_NAME';
export const AFTERCARE_FORM_SET_LOCATION_ID = 'AFTERCARE_FORM_SET_LOCATION_ID';
export const AFTERCARE_FORM_SET_GRADE = 'AFTERCARE_FORM_SET_GRADE';
export const AFTERCARE_FORM_SET_AGE = 'AFTERCARE_FORM_SET_AGE';
export const AFTERCARE_FORM_SET_GRADE_TO = 'AFTERCARE_FORM_SET_GRADE_TO';
export const AFTERCARE_FORM_SET_GRADE_FROM = 'AFTERCARE_FORM_SET_GRADE_FROM';
export const AFTERCARE_FORM_SET_AGE_TO = 'AFTERCARE_FORM_SET_AGE_TO';
export const AFTERCARE_FORM_SET_AGE_FROM = 'AFTERCARE_FORM_SET_AGE_FROM';
export const AFTERCARE_FORM_SET_AFTERCARE_DESCRIPTION = 'AFTERCARE_FORM_SET_AFTERCARE_DESCRIPTION';
//step 2
export const AFTERCARE_FORM_SET_AFTERCARE_START_DATE = 'AFTERCARE_FORM_SET_AFTERCARE_START_DATE';
export const AFTERCARE_FORM_SET_AFTERCARE_END_DATE = 'AFTERCARE_FORM_SET_AFTERCARE_END_DATE';
export const AFTERCARE_FORM_SET_NO_AFTERCARE_DATES = 'AFTERCARE_FORM_SET_NO_AFTERCARE_DATES';
export const AFTERCARE_FORM_SET_SIGN_UP_BEGINS_DATE = 'AFTERCARE_FORM_SET_SIGN_UP_BEGINS_DATE';
export const AFTERCARE_FORM_SET_SIGN_UP_ENDS_DATE = 'AFTERCARE_FORM_SET_SIGN_UP_ENDS_DATE';
export const AFTERCARE_FORM_SET_SIGN_UP_BEGINS_TIME = 'AFTERCARE_FORM_SET_SIGN_UP_BEGINS_TIME';
export const AFTERCARE_FORM_SET_SIGN_UP_ENDS_TIME = 'AFTERCARE_FORM_SET_SIGN_UP_ENDS_TIME';
//step 3
export const AFTERCARE_FORM_ADD_DAY = 'AFTERCARE_FORM_ADD_DAY';
export const AFTERCARE_FORM_REMOVE_DAY = 'AFTERCARE_FORM_REMOVE_DAY';
export const AFTERCARE_FORM_SET_DAY_TIME_FROM = 'AFTERCARE_FORM_SET_DAY_TIME_FROM';
export const AFTERCARE_FORM_SET_DAY_TIME_TO = 'AFTERCARE_FORM_SET_DAY_TIME_TO';
export const AFTERCARE_FORM_SET_DAY_MAX_ENROLL = 'AFTERCARE_FORM_SET_DAY_MAX_ENROLL';
export const AFTERCARE_FORM_SET_DAY_WAITLIST = 'AFTERCARE_FORM_SET_DAY_WAITLIST';
export const AFTERCARE_FORM_SET_DAY_MAX_WAITLIST = 'AFTERCARE_FORM_SET_DAY_MAX_WAITLIST';
export const AFTERCARE_FORM_SET_DAY_DROPIN = 'AFTERCARE_FORM_SET_DAY_DROPIN';
export const AFTERCARE_FORM_SET_DAY_MAX_DROPIN = 'AFTERCARE_FORM_SET_DAY_MAX_DROPIN';
export const AFTERCARE_FORM_SET_DAY_INSTRUCTOR_ID = 'AFTERCARE_FORM_SET_DAY_INSTRUCTOR_ID';
//step 4
export const AFTERCARE_FORM_SET_PRICE = 'AFTERCARE_FORM_SET_PRICE';
export const AFTERCARE_FORM_SET_PRORATE = 'AFTERCARE_FORM_SET_PRORATE';
export const AFTERCARE_FORM_SET_BILLING_TYPE = 'AFTERCARE_FORM_SET_BILLING_TYPE';
export const AFTERCARE_FORM_SET_CHARGE_TYPE = 'AFTERCARE_FORM_SET_CHARGE_TYPE';
export const AFTERCARE_FORM_SET_BILLING_RATE = 'AFTERCARE_FORM_SET_BILLING_RATE';
export const AFTERCARE_FORM_SET_DROP_IN_PRICE = 'AFTERCARE_FORM_SET_DROP_IN_PRICE';
export const AFTERCARE_FORM_SET_DROP_IN_BILLING_RATE = 'AFTERCARE_FORM_SET_DROP_IN_BILLING_RATE';
export const AFTERCARE_FORM_SET_DISCOUNTS_OPENED = 'AFTERCARE_FORM_SET_DISCOUNTS_OPENED';
export const AFTERCARE_FORM_SET_DISCOUNTS_DAY_ACTIVE = 'AFTERCARE_FORM_SET_DISCOUNTS_DAY_ACTIVE';
export const AFTERCARE_FORM_SET_DISCOUNTS_TWO_DAYS_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_TWO_DAYS_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_THREE_DAYS_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_THREE_DAYS_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_FOUR_DAYS_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_FOUR_DAYS_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_FIVE_DAYS_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_FIVE_DAYS_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_SIX_DAYS_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_SIX_DAYS_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_SEVEN_DAYS_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_SEVEN_DAYS_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_CHILD_ACTIVE = 'AFTERCARE_FORM_SET_DISCOUNTS_CHILD_ACTIVE';
export const AFTERCARE_FORM_SET_DISCOUNTS_TWO_CHILDREN_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_TWO_CHILDREN_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_THREE_CHILDREN_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_THREE_CHILDREN_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_FOUR_CHILDREN_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_FOUR_CHILDREN_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_FIVE_CHILDREN_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_FIVE_CHILDREN_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_SIX_CHILDREN_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_SIX_CHILDREN_AMOUNT';
export const AFTERCARE_FORM_SET_DISCOUNTS_SEVEN_CHILDREN_AMOUNT = 'AFTERCARE_FORM_SET_DISCOUNTS_SEVEN_CHILDREN_AMOUNT';
export const SET_AFTERCARE_ADDONS = 'SET_AFTERCARE_ADDONS';
export const AFTERCARE_FORM_SET_ADDONS_OPENED = 'AFTERCARE_FORM_SET_ADDONS_OPENED';
export const AFTERCARE_FORM_ADD_ADDON = 'AFTERCARE_FORM_ADD_ADDON';
export const AFTERCARE_FORM_SET_ADDON_NAME = 'AFTERCARE_FORM_SET_ADDON_NAME';
export const AFTERCARE_FORM_SET_ADDON_PRICE = 'AFTERCARE_FORM_SET_ADDON_PRICE';
export const AFTERCARE_FORM_SET_ADDON_REQUIRED = 'AFTERCARE_FORM_SET_ADDON_REQUIRED';
export const AFTERCARE_FORM_SET_ADDON_DISCOUNT = 'AFTERCARE_FORM_SET_ADDON_DISCOUNT';
export const AFTERCARE_FORM_SET_ADDON_MAX_AMOUNT = 'AFTERCARE_FORM_SET_ADDON_MAX_AMOUNT';
export const AFTERCARE_FORM_REMOVE_AFTERCARE_ADDON = 'AFTERCARE_FORM_REMOVE_AFTERCARE_ADDON';
export const AFTERCARE_FORM_SET_DETAILS_OPENED = 'AFTERCARE_FORM_SET_DETAILS_OPENED';
export const AFTERCARE_FORM_SET_PICKUP_OPTIONS = 'AFTERCARE_FORM_SET_PICKUP_OPTIONS';
export const AFTERCARE_FORM_SET_PICKUP_OPTIONS_REQUIRED = 'AFTERCARE_FORM_SET_PICKUP_OPTIONS_REQUIRED';
export const AFTERCARE_FORM_SET_TEACHER = 'AFTERCARE_FORM_SET_TEACHER';
export const AFTERCARE_FORM_SET_TEACHER_REQUIRED = 'AFTERCARE_FORM_SET_TEACHER_REQUIRED';
export const AFTERCARE_FORM_SET_T_SHIRT = 'AFTERCARE_FORM_SET_T_SHIRT';
export const AFTERCARE_FORM_SET_T_SHIRT_REQUIRED = 'AFTERCARE_FORM_SET_T_SHIRT_REQUIRED';
export const AFTERCARE_FORM_SET_CUSTOM_FORM_OPENED = 'AFTERCARE_FORM_SET_CUSTOM_FORM_OPENED';


// WEBPACK FOOTER //
// ./src/store/modules/aftercare-form/mutations.js